import type { FunctionComponent } from "react";
import { Button } from "../../ui/button";
import { useToast } from "../../../hooks/use-toast";
import { handleHttpError } from "../../../utils/utils";
import Spinner from "../../spinner.components";
import { useAddSocialToFavoriteCollectionAdminHttp } from "../../../hooks/http/admin/favorites/add-social-to-favorite-collection.admin.http";
import type { ISocial } from "../../../types/models/social.models.types";
import { useParams } from "react-router-dom";

type AppProps = {
	removeById: (id: string) => void;
	social: ISocial;
	className?: string;
};

export const AddToGroup: FunctionComponent<AppProps> = ({
	social,
	removeById,
	className,
}) => {
	const { favoriteId } = useParams();

	const {
		execute: addSocialToFavoriteCollectionHttp,
		fetching: fetchingAddSocialToFavoriteCollection,
	} = useAddSocialToFavoriteCollectionAdminHttp();

	const { toast } = useToast();

	const handleAddToGroup = async () => {
		if (!favoriteId) {
			return;
		}

		const response = await addSocialToFavoriteCollectionHttp({
			pathParams: { id: favoriteId },
			body: {
				socials: [social.id],
			},
		});

		if (!response.success) {
			return handleHttpError(response, toast);
		}
		removeById(social.id);
	};

	return (
		<Button
			disabled={fetchingAddSocialToFavoriteCollection}
			onClick={handleAddToGroup}
			className={`border-approvebuttonborder w-32 h-10 bg-approvebuttonbg border font-semibold text-approvebuttontext tracking-wider ${className}`}
		>
			{fetchingAddSocialToFavoriteCollection ? (
				<Spinner width={15} />
			) : (
				"add to group"
			)}
		</Button>
	);
};
